import { styled } from "@mui/material";

export const Styled = {
    Container: styled("div")``,
};
